// Mock data for Hollis K9 website

export const mockData = {
  hero: {
    title: "Creating happy families and well-trained dogs.",
    description: "If you're here, you probably know the stress of managing a dog with behavioral challenges — the anxious walks, the constant pulling, the jumping, the fear, the frustration, or the moments that make you worry. We've been there, and we're here to help!",
    primaryCTA: "BOOK A PHONE CALL",
    secondaryCTA: "ZOOM ASSESSMENT",
    serviceArea: "We serve Tulsa, Bartlesville, Muskogee, and surrounding areas in person and virtually from anywhere."
  },
  
  intro: {
    text: "We use modern, results-driven methods tailored to each dog, combining kindness with effectiveness. Our personalized coaching helps owners achieve reliable results in a supportive environment, addressing unwanted behaviors, basic-to-advanced obedience, manners, and more serious issues like reactivity or aggression. We also offer specialty training in sports, scentwork, shed hunting, and wounded game recovery, all aimed at creating a happier, more harmonious life with your dog."
  },
  
  services: [
    {
      id: 1,
      title: "PRIVATE TRAINING",
      description: "These sessions may be at our facility, your home, or at a local dog friendly location. We coach you through a customized training plan tailor-made to fit your goals you have for your dog and so we may address any behavior problems your dog may have as well.",
      image: "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=800&q=80"
    },
    {
      id: 2,
      title: "VIRTUAL TRAINING",
      description: "Train your dog from the comfort of your own home! We will create a custom training and management plan to meet your personal goals with your dog.",
      image: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&q=80"
    },
    {
      id: 3,
      title: "BOARD AND TRAIN",
      description: "Send your dog to \"Doggy Boot Camp\" to live with a pro trainer to speed up their training process. Get a solid foundation of clear communication, obedience, and manners. Behavior problems like impulse control, fear, anxiety, and reactivity will also be addressed.",
      image: "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=800&q=80"
    }
  ],
  
  about: {
    title: "About Owner, Courtney Hollis",
    bio: "Courtney has cultivated a love for animals her entire life. Having grown up helping train horses with her grandfather in Missouri, she eventually started her own business as a horse trainer. She took a break from training when raising her kiddos in 2013. In 2015, her family dog was struggling with fear and anxiety, so she dove into studying dog psychology and behavior in order to help her own dog. She loved the relationship and trust she built with her dog through this training and wanted to help other people build the same relationship with their dogs! After spending years educating herself, earning certifications, developing her skills while working under other professional trainers and taking part in many dog sports like IGP (tracking, obedience, and protection), dock diving, nose work, shed hunting, and disc, Courtney decided to open up her own training business to help busy and frustrated families tame and train their canine family members!",
    image: "/courtney-about-new.jpg",
    cta: "BOOK COURTNEY HERE"
  },
  
  testimonials: [
    {
      id: 1,
      name: "Sarah M.",
      text: "Courtney transformed our reactive dog into a calm companion. Her methods really work!",
      rating: 5
    },
    {
      id: 2,
      name: "John D.",
      text: "The board and train program was life-changing. Our dog came back so well-behaved!",
      rating: 5
    },
    {
      id: 3,
      name: "Emily R.",
      text: "Virtual training was so convenient and effective. Highly recommend!",
      rating: 5
    }
  ],
  
  contact: {
    phone: "+1 918-500-9422",
    email: "hollisk9coaching@gmail.com",
    address: "Tulsa, Oklahoma"
  }
};